import { computed, type ComputedRef } from 'vue';
import { useUserConfig } from '@/store/user-config';

/**
 * Where the header's help icon points. Brand-configurable, so the two places
 * that offer it — the bar's icon and the phone menu's row — read it from here
 * rather than each carrying its own fallback.
 */
export function useHelpPageUrl(): ComputedRef<string> {
  return computed(() => useUserConfig()?.settings?.header?.helpLink ?? 'https://learn.resourced.com/en/');
}
